<template>
  <div>
    <v-dialog v-model="removeModal" max-width="400" persistent>
      <v-card class="pa-4 text-center" :key="removeKey">
        <h3 class="mb-4">Remover vídeo</h3>
        <p>
          Tem certeza de que deseja <strong>remover</strong> o vídeo
          <strong>"{{ current.title }}"</strong>
        </p>
        <v-btn class="primary-button" depressed @click="removeModal = false">
          Cancelar
        </v-btn>
        <v-btn class="secondary-button mr-0" depressed @click="remove" :loading="loading">
          Remover
        </v-btn>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editModal" max-width="500" persistent>
      <Manage
        :engType="engType"
        :item="current"
        @close=";(editKey = !editKey), (editModal = false)"
        @confirm="onVideoEdited"
        :key="editKey"
      />
    </v-dialog>

    <v-dialog v-model="playerModal" max-width="800" @click:outside="closePlayer">
      <v-card class="pa-4" v-if="playerModal">
        <v-btn absolute top right @click="closePlayer" text icon>
          <v-icon small> mdi-close </v-icon>
        </v-btn>
        <h3 class="ml-3">{{ currentPlayer.title }}</h3>
        <div class="d-flex justify-center align-center">
          <iframe
            :src="`https://player.vimeo.com/video/${currentPlayer.videoId}?h=a75baf7391`"
            width="740"
            height="460"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </v-card>
    </v-dialog>

    <v-row class="ma-0 mt-4">
      <v-col cols="12" sm="6" md="4" v-for="video in videos" :key="video.id">
        <v-hover v-slot="{ hover }">
          <v-card
            id="video"
            outlined
            class="pa-4 rounded-lg"
            :class="{ 'on-hover': hover }"
          >
            <img
              @click="openPlayer(video)"
              :src="`https://vumbnail.com/${video.videoId}.jpg`"
              alt=""
              class="videoImage mb-2"
            />
            <div class="d-flex justify-space-between align-center">
              <strong>{{ video.title }}</strong>
              <div class="d-flex align-center" v-if="user.mainType == 0">
                <v-btn
                  text
                  icon
                  small
                  @click=";(current = { ...video }), (editKey = !editKey), (editModal = true)"
                >
                  <v-icon color="secondary">mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn
                  text
                  icon
                  small
                  @click=";(current = video), (removeKey = !removeKey), (removeModal = true)"
                >
                  <v-icon color="error">mdi-trash-can-outline</v-icon>
                </v-btn>
              </div>
            </div>
            <div class="btn-container">
              <v-btn @click="openPlayer(video)" :class="{ 'show-btns': hover }" :color="transparent" icon x-large text>
                <v-icon :class="{ 'show-btns': hover }" x-large :color="transparent">
                  mdi-play
                </v-icon>
              </v-btn>
            </div>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>

    <div class="pagination mx-2">
      <div class="item-pagination block-one">
        <div class="registros" v-if="videos.length">
          <span> 1 - {{ videos.length }} de {{ totalItems }} </span>
        </div>
      </div>
      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="totalPages"
          :total-visible="5"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '../../../../services/ApiService'
import Manage from './manage.vue'

export default {
  components: {
    Manage,
  },

  props: {
    engType: { type: Number, default: 0 },
    user: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      videos: [],
      page: 1,
      totalPages: 0,
      totalItems: 0,
      current: {},
      currentPlayer: {},
      playerModal: false,
      removeModal: false,
      removeKey: false,
      editModal: false,
      editKey: false,
      loading: false,
      transparent: 'rgba(255, 255, 255, 0)',
      apiService: new ApiService(),
    }
  },

  created() {
    this.list()
  },

  methods: {
    loadData() {
      this.page = 1
      this.list()
    },

    list() {
      const endpoint = this.engType === 1 ? 'video/infra/paginate' : 'video/clinic/paginate'
      this.apiService.get(`${endpoint}/${this.page}`).then((response) => {
        this.videos = response.content.videos.map((x) => ({
          id: x.id,
          title: x.title,
          link: x.link,
          videoId: x.link.split('/').pop(),
        }))
        this.page = response.content.pager.currentPage
        this.totalPages = response.content.pager.totalPages
        this.totalItems = response.content.pager.totalItems
      })
    },

    openPlayer(video) {
      this.currentPlayer = video
      this.playerModal = true
    },

    closePlayer() {
      this.playerModal = false
    },

    onVideoEdited() {
      this.editKey = !this.editKey
      this.editModal = false
      this.current = {}
      this.list()
    },

    remove() {
      this.loading = true
      this.apiService.delete(`video/${this.current.id}`).then(() => {
        this.loading = false
        this.removeModal = false
        this.current = {}
        this.$toast.success('Vídeo removido com sucesso!')
        this.list()
      }).catch(() => {
        this.loading = false
      })
    },
  },

  watch: {
    page() {
      this.list()
    },
    playerModal(value) {
      if (!value) {
        this.currentPlayer = {}
      }
    },
  },
}
</script>

<style scoped>
.btn-container {
  position: absolute;
  margin: auto;
  top: 34%;
  left: 42%;
}

#video {
  transition: opacity 0.4s ease-in-out;
  position: relative;
}

#video:not(.on-hover) {
  opacity: 0.8;
}

.show-btns {
  color: #fff !important;
}

.videoImage {
  border-radius: 10px;
  width: 100%;
}
</style>
